import { render, staticRenderFns } from "./PedidosListItemMobile.vue?vue&type=template&id=7ec6c576&"
import script from "./PedidosListItemMobile.vue?vue&type=script&lang=ts&"
export * from "./PedidosListItemMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports